export default function Comparison() {
  const rows = [
    { feature: "Publicidad invasiva",                facebook: "constante",       ovamx: "cero" },
    { feature: "Alcance orgánico",                   facebook: "limitado",        ovamx: "completo" },
    { feature: "Perfiles falsos",                    facebook: "millones",        ovamx: "verificados" },
    { feature: "Algoritmo manipulador",              facebook: "opaco",           ovamx: "explicable" },
    { feature: "Privacidad por defecto",             facebook: "no",              ovamx: "sí" },
    { feature: "Monetización para usuarios normales",facebook: "casi nula",       ovamx: "6 flujos" },
    { feature: "IA personal integrada",              facebook: "no",              ovamx: "nativa" },
    { feature: "Marketplace global",                 facebook: "fragmentado",     ovamx: "unificado" },
    { feature: "Modo de descubrimiento separado",    facebook: "no",              ovamx: "Modo Horizonte" },
    { feature: "Comunidades reales",                 facebook: "diluidas",        ovamx: "vivas" },
  ];

  return (
    <section
      data-testid="comparison"
      className="py-24 md:py-40 bg-cream"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 mb-16">
          <div className="col-span-12 md:col-span-7">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral">
              ◊ Ovamx vs redes actuales
            </p>
            <h2 className="mt-5 font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tighter">
              No competimos.<br />
              <span className="italic">Sustituimos.</span>
            </h2>
          </div>
          <p className="col-span-12 md:col-span-5 md:pt-10 text-lg text-ink/75 leading-relaxed text-balance">
            Cada función nace de un punto de dolor real reportado por miles de usuarios. Esta tabla no es marketing — es la arquitectura del producto.
          </p>
        </div>

        <div className="border-t hairline">
          {/* Header row */}
          <div className="grid grid-cols-12 py-6 border-b hairline font-mono text-[10px] uppercase tracking-[0.25em] text-ink-mid">
            <div className="col-span-6">funcionalidad</div>
            <div className="col-span-3 text-ink/40">Facebook</div>
            <div className="col-span-3 text-coral">Ovamx</div>
          </div>

          {rows.map((r, i) => (
            <div
              key={r.feature}
              data-testid={`compare-row-${i}`}
              className="grid grid-cols-12 py-5 md:py-6 border-b hairline items-center hover:bg-cream-deep/40 transition-colors duration-500"
            >
              <div className="col-span-6 font-serif text-xl md:text-2xl leading-tight pr-4">
                {r.feature}
              </div>
              <div className="col-span-3 text-sm text-ink/40">
                <span className="line-through decoration-1">{r.facebook}</span>
              </div>
              <div className="col-span-3 text-base md:text-lg font-medium text-ink flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-coral" />
                {r.ovamx}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
